import ScrollAnimation from 'react-animate-on-scroll';
import me from '../assets/images/me.jpg';
import html5 from '../assets/images/html5.png';
import css3 from '../assets/images/css3.png';
import java from '../assets/images/java.png';
import javascript from '../assets/images/javascript.png';
import rails from '../assets/images/rails.png';
import react from '../assets/images/react.png';
import spring from '../assets/images/spring.png';
import angular from '../assets/images/angular.png';
import graphql from '../assets/images/graphql.png';

const About = () => {
  return (
    <section id="about">
      <ScrollAnimation animateOnce={true} animateIn="fadeInLeft">
        <div className="header">
          <div className="headerText">
            <span>ABOUT</span>
            <ScrollAnimation animateOnce={true} className="headerBar" delay={500} animateIn="fadeInLeft">
            </ScrollAnimation>
          </div>
        </div>
      </ScrollAnimation>
      <div className="dataFlex">
        <div className="boxHolder">
          <div className="dataBox">
            <ScrollAnimation animateIn="flipInY" animateOnce={true} delay={100}>
              <div className="hexagon">
                <span className="iconify" data-icon="mdi:web" data-inline="false"></span>
              </div>
            </ScrollAnimation>
            <ScrollAnimation className="dataDesc" animateIn="fadeIn" delay={100} animateOnce={true}>
              <div className="dataHeaders">Interactive</div>
              <div className="dataPara">Designing interactive websites with up-to-date technology.</div>
            </ScrollAnimation>
          </div>
          <div className="dataBox">
            <ScrollAnimation animateIn="flipInY" animateOnce={true} delay={200}>
              <div className="hexagon">
                <span className="iconify" data-icon="mdi:cellphone-link" data-inline="false"></span>
              </div>
            </ScrollAnimation>
            <ScrollAnimation className="dataDesc" animateIn="fadeIn" delay={100} animateOnce={true}>
              <div className="dataHeaders">Responsive</div>
              <div className="dataPara">My designs responds for every device, big or small.</div>
            </ScrollAnimation>
          </div>
        </div>
        <div className="boxHolder">
          <div className="dataBox">
            <ScrollAnimation animateIn="flipInY" animateOnce={true} delay={300}>
              <div className="hexagon">
                <span className="iconify" data-icon="teenyicons:bulb-off-outline" data-inline="false"></span>
              </div>
            </ScrollAnimation>
            <ScrollAnimation className="dataDesc" animateIn="fadeIn" delay={100} animateOnce={true}>
              <div className="dataHeaders">Intuitive</div>
              <div className="dataPara">Strong preference for providing intuitive web designs.</div>
            </ScrollAnimation>
          </div>
          <div className="dataBox">
            <ScrollAnimation animateIn="flipInY" animateOnce={true} delay={400}>
              <div className="hexagon">
                <span className="iconify" data-icon="mdi:rocket-launch-outline" data-inline="false"></span>
              </div>
            </ScrollAnimation>
            <ScrollAnimation className="dataDesc" animateIn="fadeIn" delay={100} animateOnce={true}>
              <div className="dataHeaders">Dynamic</div>
              <div className="dataPara">Websites don't have to be static, I love making pages come to life.</div>
            </ScrollAnimation>
          </div>
        </div>
      </div>
      <div className="descGrid">
        <div>
          <ScrollAnimation animateOnce={true} animateIn="fadeInLeft" offset={300}>
            <div className="portfolio">
              <img src={me} alt="" className="portfolioImg" />
              <ScrollAnimation className="portfolioDesc" animateIn="fadeInUp" animateOnce={true}>
                As a passionate Full-stack Developer, I bring a dedicated mindset to overcoming complex challenges. I thrive on continuous learning, constantly expanding my skills to incorporate useful technologies. My commitment extends beyond problem-solving, as I actively implement these new technologies to address diverse use cases. This portfolio reflects my journey as a dynamic developer who embraces challenges and embraces innovation to deliver effective solutions.
              </ScrollAnimation>
            </div>
          </ScrollAnimation>
        </div>
        <div>
          <ScrollAnimation animateIn="fadeInRight" animateOnce={true} offset={300}>
            <div className="logos">
              <ScrollAnimation animateIn="fadeIn" animateOnce={true} delay={100}>
                <img src={html5} alt="" className="progLogo" />
              </ScrollAnimation>
              <ScrollAnimation animateIn="fadeIn" animateOnce={true} delay={200}>
                <img src={css3} alt="" className="progLogo" />
              </ScrollAnimation>
              <ScrollAnimation animateIn="fadeIn" animateOnce={true} delay={300}>
                <img src={java} alt="" className="progLogo" />
              </ScrollAnimation>
              <ScrollAnimation animateIn="fadeIn" animateOnce={true} delay={400}>
                <img src={spring} alt="" className="progLogo" />
              </ScrollAnimation>
              <ScrollAnimation animateIn="fadeIn" animateOnce={true} delay={500}>
                <img src={rails} alt="" className="progLogo" />
              </ScrollAnimation>
              <ScrollAnimation animateIn="fadeIn" animateOnce={true} delay={600}>
                <img src={javascript} alt="" className="progLogo" />
              </ScrollAnimation>
              <ScrollAnimation animateIn="fadeIn" animateOnce={true} offset={-20} delay={600}>
                <img src={angular} alt="" className="progLogo" />
              </ScrollAnimation>
              <ScrollAnimation animateIn="fadeIn" animateOnce={true} offset={-20} delay={600}>
                <img src={react} alt="" className="progLogo" />
              </ScrollAnimation>
              <ScrollAnimation animateIn="fadeIn" animateOnce={true} offset={-20} delay={600}>
                <img src={graphql} alt="" className="progLogo" />
              </ScrollAnimation>
            </div>
          </ScrollAnimation>
        </div>
      </div>
    </section>
  )
}

export default About;
